import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { Stack } from "@mui/material";

function Loader({ loading, size = 50 }) {
  return (
    <Stack alignItems="center" width="100%" justifyContent="center">
      <ClipLoader size={size} color="#4DAF51" loading={loading} />
    </Stack>
  );
}

export default Loader;
